module.exports = __webpack_public_path__ + "static/media/Emer-bannerweb-7.749a1b94.png";